import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "primereact/resources/themes/saga-green/theme.css";  //theme
import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css";                                //icons
import App from './App';
import * as Sentry from "@sentry/react";
import {BrowserTracing} from "@sentry/tracing";
import reportWebVitals from './reportWebVitals';

/**
 * Free Themes
 */

// primereact/resources/themes/bootstrap4-light-blue/theme.css
// primereact/resources/themes/bootstrap4-light-purple/theme.css
// primereact/resources/themes/bootstrap4-dark-blue/theme.css
// primereact/resources/themes/bootstrap4-dark-purple/theme.css
// primereact/resources/themes/md-light-indigo/theme.css
// primereact/resources/themes/md-light-deeppurple/theme.css
// primereact/resources/themes/md-dark-indigo/theme.css
// primereact/resources/themes/md-dark-deeppurple/theme.css
// primereact/resources/themes/mdc-light-indigo/theme.css
// primereact/resources/themes/mdc-light-deeppurple/theme.css
// primereact/resources/themes/mdc-dark-indigo/theme.css
// primereact/resources/themes/mdc-dark-deeppurple/theme.css
// primereact/resources/themes/tailwind-light/theme.css
// primereact/resources/themes/fluent-light/theme.css
// primereact/resources/themes/lara-light-blue/theme.css
// primereact/resources/themes/lara-light-indigo/theme.css
// primereact/resources/themes/lara-light-purple/theme.css
// primereact/resources/themes/lara-light-teal/theme.css
// primereact/resources/themes/lara-dark-blue/theme.css
// primereact/resources/themes/lara-dark-indigo/theme.css
// primereact/resources/themes/lara-dark-purple/theme.css
// primereact/resources/themes/lara-dark-teal/theme.css
// primereact/resources/themes/saga-blue/theme.css
// primereact/resources/themes/saga-green/theme.css
// primereact/resources/themes/saga-orange/theme.css
// primereact/resources/themes/saga-purple/theme.css
// primereact/resources/themes/vela-blue/theme.css
// primereact/resources/themes/vela-green/theme.css
// primereact/resources/themes/vela-orange/theme.css
// primereact/resources/themes/vela-purple/theme.css
// primereact/resources/themes/arya-blue/theme.css
// primereact/resources/themes/arya-green/theme.css
// primereact/resources/themes/arya-orange/theme.css
// primereact/resources/themes/arya-purple/theme.css
// primereact/resources/themes/nova/theme.css
// primereact/resources/themes/nova-alt/theme.css
// primereact/resources/themes/nova-accent/theme.css
// primereact/resources/themes/luna-amber/theme.css
// primereact/resources/themes/luna-blue/theme.css
// primereact/resources/themes/luna-green/theme.css
// primereact/resources/themes/luna-pink/theme.css
// primereact/resources/themes/rhea/theme.css

/**
 *
 */

Sentry.init({
    dsn: "https://4bb34123057240ecbb2a40088bd9312f@o4504021877522432.ingest.sentry.io/4504021888401408",
    integrations: [new BrowserTracing()],
    release: "mynhaka@2.0.1",
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});

ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
